import React, { useEffect, useState } from "react";

import "../../../collection/styles/collectionScreen.css";
import collectionDataJson from "../../../../db/collectionData.json";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import Card from "components/ui/Card";
import { Grid, Skeleton, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import { ReactComponent as TrashIcon } from "assets/icons/trash.svg";
import { ReactComponent as DescriptionIcon } from "assets/icons/descriptionicon.svg";
import { ReactComponent as SparkleIcon } from "assets/icons/Sparkle.svg";

import { ReactComponent as EditIcon } from "assets/icons/CatalogueCard/edit.svg";

import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import config from "configs/config";
import SortContext from "context/SortContext";
import { encodeStr } from "utils/encodeDecodeStr";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";
import apiClient from "lib/api-client";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import CollectionEditModal from "../Modal/CollectionEditModal";
import { toast } from "react-toastify";
import { formatDate } from "utils/formatDate";
import CollectionDiscriptionModal from "../Modal/CollectionDiscriptionModal";
import useGetCollections from "features/collection/hooks/useGetCollections";
import useGetAICollections from "features/collection/hooks/useGetAICollections";
import { useFilter } from "context/FilterContext";
import InfoModal from "components/ui/InfoModal/InfoModal";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function CollectionScreen() {
  const { search, setSearch, selectedSortValue, setIsEdit, isEdit, setIsEditClick, isCollectionEdit, setIsCollectionEdit } = React.useContext(SortContext);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [openEditNameModal, setOpenEditNameModal] = useState(false);
  const [openDiscriptionModal, setOpenDiscriptionModal] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [collectionFetchId, setCollectionFetchId] = useState(null);
  const [discriptionData, setDiscriptionData] = useState({});
  const [currentCollectionData, setCurrentCollectionData] = useState({});

  const [collectionRemovePayload, setCollectionRemovePayload] = useState({});
  let [collectionData, setCollectionData] = useState(collectionDataJson);

  const navigate = useNavigate();
  const location = useLocation();
  // console.log("Collection Page Location ", location)

  const innerChnages = location?.state?.innerChnages;
  const collectionPresent = location?.state?.collection;

  const {
    setCreateBtn,
    setCreateBtnName,
    setCreateBtnOption,
    showCollectionTrashIcon,
    setShowCollectionTrashIcon,
    setCollectionUpdate,
    setOpenCancelModal,
    openCancelModal,
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setDynamicFilterCount,
    filterChangeDesignCount,
    setSearchResultCount,
    filterChangeCount,
    dynamicfilterCount,
    setSearchPlaceHolder,
  } = useGlobalContext();
  const { setIsCollectionFilter, setBackendFilterValues, setFilterValues, filterValues, setFilterCount, setAppliedFilterValues } = useFilter();
  const permission = usePermissions();

  const hasAccessAddCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "create");
   const hasAccessViewCategory = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view");
  const hasAccessToCreate = hasAccessAddCollection && hasAccessViewCategory;
  const hasAccessViewName = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "edit_names"); //colection name change
  const hasAccessDeleteCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "delete"); //collection delete

  const hasAccessToSeeAICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "all");
  const hasAccessToSeeTop30AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "top30_sold_30_days");
  const hasAccessToSeeTop60AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "top60_sold_60_days");
  const hasAccessToSeeTop90AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "top90_sold_90_days");

  const hasAccessToSeeNew30AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "new30_sold_30_days");
  const hasAccessToSeeNew60AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "new60_sold_60_days");
  const hasAccessToSeeNew90AICollection = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "new90_sold_90_days");

  const hasAccessToSeeCadDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "cad_designs");
  const hasAccessToSeeDuplicateStocks = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "duplicate_stocks");
  const hasAccessToSeeRestrictedStocks = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "restricted_stocks");

  const hasAccessToSee1To2YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "1to2years_old_stocks");
  const hasAccessToSee2To3YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "2to3years_old_stocks");
  const hasAccessToSee3To4YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "3to4years_old_stocks");
  const hasAccessToSee4To5YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "4to5years_old_stocks");
  const hasAccessToSee5To6YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "5to6years_old_stocks");
  const hasAccessToSee6To7YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "6to7years_old_stocks");
  const hasAccessToSee7To8YearsOldStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "7to8years_old_stocks");

  const hasAccessToSeeBinnysSelectDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "binny’s_select_design");
   const hasAccessToNewtDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "new_designs");
  const hasAccessToSeeNewDesignOutOfStock = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "new_design_out_of_stock");
  const hasAccessToSee1_2Years_DesignOutOfStockDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "1_2years_design_out_of_stock");
  const hasAccessToSee2_3Years_DesignOutOfStockDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "2_3years_design_out_of_stock");

  const hasAccessToSeeUnderRatioDesignsDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "under_ratio_design");
  const hasAccessToSeeOverRatioDiamondDesigns = isAllowed(findSpecificSubPage(findSpecificPage("Vision Web", permission), "AI Collection"), "over_ratio_design");

  useEffect(() => {
    setSearch(location?.state?.collectionSearch || "");
  }, [location]);

  //------------------------ Handling API Integration Start(User Created Collections ) -----------------------\\
  const payload = {
    pageNumber: 1,
    limit: 100,
    searchTerm: search, //Winter Collection
    sortBy:
      selectedSortValue == "1" || selectedSortValue == "2"
        ? "alphabetical"
        : selectedSortValue == "3" || selectedSortValue == "4"
          ? "quantity"
          : selectedSortValue == "5"
            ? "collectionDate"
            : selectedSortValue == "6"
              ? "latestModified"
              : "alphabetical",
    order: selectedSortValue == null || selectedSortValue == "1" || selectedSortValue == "4" ? "asc" : "desc", //asc //desc
  };
  const { data: collections, isLoading: isCollectionLoading, error, isError, refetch } = useGetCollections(payload);
  //------------------------ Handling API Integration Start(AI Collections ) -----------------------\\

  const aiPayload = {
    searchTerm: search,
  };
  const { data: aicollections, isLoading: isAiLoading, aierror, isAiError } = useGetAICollections(aiPayload);

  //------------------------ Handling API Integration End -----------------------\\

  useEffect(() => {
    setSearchPlaceHolder("Search By Collection or Design Number");
    sessionStorage.removeItem("collectionIdOfProducts");
    if (search === "") {
      setDynamicFilterCount(true);
    }
    const filteredCollections = filterValues?.aiCollectionFilter?.includes("User-created Collection") ? collections?.collections || [] : [];

    const filteredAiCollections = filterValues?.aiCollectionFilter?.includes("Ai Collection") ? aicollections?.designs || [] : [];
    const accesibleAiCollections = filteredAiCollections.filter((design) => {
      const { days, newDesign, cadDesign, designCount, duplicateStock, restricateStock, range, selectDesign, isOutOfStock, UnderRatio, OverRatio, newDesigns, collectionName } = design;
      return checkAccessToShowAiCollection(days, newDesign, cadDesign, designCount, duplicateStock, restricateStock, range, selectDesign, isOutOfStock, UnderRatio, OverRatio, newDesigns, collectionName);
    });

    if (dynamicfilterCount) {
      if (collections && aicollections) {
        // apply acccess check for AI Collections
        const accesibleAiCollections = filteredAiCollections.filter((design) => {
          const { days, newDesign, cadDesign, designCount, duplicateStock, restricateStock, range, selectDesign, isOutOfStock, UnderRatio, OverRatio, newDesigns, collectionName } = design;
          return checkAccessToShowAiCollection(days, newDesign, cadDesign, designCount, duplicateStock, restricateStock, range, selectDesign, isOutOfStock, UnderRatio, OverRatio, newDesigns, collectionName);
        });

        // count collections and designs based only on access
        const accesibleCollectionCount = filteredCollections.length + accesibleAiCollections.length;

        const accesibleDesignCount =
          filteredCollections.reduce((sum, item) => sum + (item.collectionDetails?.numberOfStyles || 0), 0) + accesibleAiCollections.reduce((sum, design) => sum + (design.designCount || 0), 0);

        setFilterChangeCount(accesibleCollectionCount);
        setFilterChangeDesignCount(accesibleDesignCount);
        setSearchResultCount(filteredCollections.length > 0 ? filteredCollections.length : 0);
        setCollectionData(filteredCollections);
      }
    } else {
      setCollectionData(filteredCollections);

      // setSearchResultCount(filteredCollections.length + accesibleAiCollections.length);
      setSearchResultCount(filteredCollections.length + accesibleAiCollections.length);
      setFilterChangeCount(filterChangeCount);
      setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchPlaceHolder("");
    };
  }, [collections, aicollections, filterValues]);

  //------------------------ API AI Collection  --------------------------------\\

  //------------------ Handle Navigate to Collection Category Page  --------------------\\
  const handleClick = (ele) => {
    const encodedName = encodeURIComponent(ele.collectionDetails.collectionName);
    const state = {
      ...location.state,
      name: [`${ele.collectionDetails.collectionName}`],
      collection: collectionPresent === undefined || null ? true : collectionPresent,
      days: "",
      isCadDesign: false,
      OverRatio: false,
      UnderRatio: false,
      collectionSearch: search !== "" ? search : "",
      subCollectionSearch: "",
      isSelectDesign: false,
      isOutOfStock: false,
      newDesigns:false,
    };
    navigate(`/Collection/${encodedName}`, { state });
  };

  //---------------- Handle Navigate to AI Collection Category Page --------------------\\
  const handleAiClick = (ele) => {
    const encodedName = encodeURIComponent(ele.collectionName); // Encode the name
    const rangeStock = ele?.range;
    const state = {
      ...location.state,
      name: [`${ele.collectionName}`],
      aiIcon: true,
      collection: collectionPresent === undefined || null ? true : collectionPresent,
      isNewAiDesign: ele?.newDesign,
      isCadDesign: ele?.cadDesign,
      isStockDesign: encodedName.endsWith("Stocks") || encodedName.endsWith("Stock") ? true : false,
      days: ele.days,
      collectionSearch: search !== "" ? search : "",
      subCollectionSearch: "",
      rangeStock: rangeStock ? rangeStock : "",
      isSelectDesign: ele.collectionName === "Binny's Select Designs" ? true : false,
      isOutOfStock: ele?.isOutOfStock,
      UnderRatio: ele?.UnderRatio,
      OverRatio: ele?.OverRatio,
      rangeOutOfStock: ele?.rangeOutOfStock,
      newDesigns: ele?.newDesigns,
    };

    // if (rangeStock) {
    //   navigate(`/Collection/${encodedName}?rangeStock=${rangeStock}`, { state });
    // } else {
    navigate(`/Collection/${encodedName}`, { state });
    // }
  };

  //----------------- handleOpenDiscriptionModal ------------------
  const handleOpenDiscriptionModal = (ele) => {
    setOpenDiscriptionModal(true);

    let discriptionModalData = {
      collectionName: ele.collectionName,
      collectionDiscription: ele?.discription,
      collectionId: ele?._id,
    };

    setDiscriptionData(discriptionModalData);
  };

  useEffect(() => {
    if (openDiscriptionModal === false) {
      refetch();
    }
  }, [openDiscriptionModal]);

  //------------------ Handle Open Trash Modal --------------------\\

  const handleOpenRemoveModal = (ele) => {
    setCollectionRemovePayload(ele.collectionDetails._id);
    setOpenRemoveModal(true);
  };

  //------------------ Handle Open Update Name Modal --------------------\\

  const handleOpenEditModal = (ele) => {
    setOpenEditNameModal(true);
    setCurrentCollectionData({ collectionId: ele.collectionDetails._id, collectionName: ele.collectionDetails.collectionName });
  };

  const handleUpdateCollection = async (tempUpdatedData) => {
    // Check if the updated name already exists in collectionData, excluding the current ID
    const isDuplicate = collectionData.some(
      (item) => item.collectionDetails._id !== tempUpdatedData.collectionId && item.collectionDetails.collectionName.trim().toLowerCase() === tempUpdatedData.collectionName.trim().toLowerCase()
    );

    // If duplicate exists, show an error and stop execution
    if (isDuplicate) {
      toast.error("Collection name already exists!", {
        autoClose: 2000,
        hideProgressBar: false,
      });
      return;
    }

    let getLocalData = JSON.parse(localStorage.getItem("tempCollectionUpdatedData")) || [];

    getLocalData.push(tempUpdatedData);

    localStorage.setItem("tempCollectionUpdatedData", JSON.stringify(getLocalData));
    // Update the collectionData state by matching the ID
    setCollectionData((prevCollectionData) =>
      prevCollectionData.map((item) =>
        item.collectionDetails._id === tempUpdatedData.collectionId
          ? {
            ...item,
            collectionDetails: {
              ...item.collectionDetails,
              collectionName: tempUpdatedData.collectionName, // Update the name
            },
          }
          : item
      )
    );
    setCollectionUpdate(true);

    setOpenEditNameModal(false);
  };

  const handleDeleteCollection = async () => {
    //First Check inside "tempCollectionUpdatedData" whetehr its present iin edited List or Not
    let UpdatedOfCollection = JSON.parse(localStorage.getItem("tempCollectionUpdatedData")) || [];
    if (UpdatedOfCollection.length > 0) {
      UpdatedOfCollection = UpdatedOfCollection.filter((obj) => obj.collectionId !== collectionRemovePayload);
      //Update localstorage of "tempCollectionUpdate"
      localStorage.setItem("tempCollectionUpdatedData", JSON.stringify(UpdatedOfCollection));
    }

    let existTempDataOfCollection = JSON.parse(localStorage.getItem("tempCollectionRemoveData")) || [];

    if (!existTempDataOfCollection.includes(collectionRemovePayload)) {
      existTempDataOfCollection.push(collectionRemovePayload);
    }
    localStorage.setItem("tempCollectionRemoveData", JSON.stringify(existTempDataOfCollection));

    // Filter out the items in collectionData based on IDs in localStorage
    const filteredCollectionData = collectionData.filter((collection) => {
      if (!existTempDataOfCollection.includes(collection.collectionDetails._id)) {
        return collection;
      }
    });
    setCollectionData(filteredCollectionData);
    setOpenRemoveModal(false);
    setCollectionUpdate(true);
  };

  //------------------ Handle Visibility of Create Button --------------------\\

  useEffect(() => {
    if (isCollectionEdit !== "view") {
      setCreateBtn(false);
    } else {
      setCreateBtn(hasAccessToCreate);
    }
  }, [isCollectionEdit]);

  //------------------ Handle Main UseEffect --------------------\\

  useEffect(() => {
    if (!innerChnages) {
      setCreateBtn(hasAccessToCreate);
      setIsCollectionFilter(true);
      setCreateBtnName("Create Collection");
      if (hasAccessDeleteCollection || hasAccessViewName) {
        setIsCollectionEdit("view");
      } else {
        setIsCollectionEdit("");
      }
      setCreateBtnOption([{ option: "By Category", link: "/Category", view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Category Access"), "view") }]);
      sessionStorage.removeItem("updateProductsData");
      sessionStorage.removeItem("collectionsProductsData");

      return () => {
        setIsCollectionEdit("");
        setCreateBtn(false);
        setIsCollectionFilter(false);
        setCreateBtnName("");
        setCreateBtnOption([]);
        setSearch("");
        setShowCollectionTrashIcon(false);
        setIsEditClick(false);
        setFilterChangeCount(0);
        setFilterChangeDesignCount(0);
        setDisplayCount(false);
        setFilterCount(0);
        localStorage.removeItem("tempCollectionRemoveData");
        localStorage.removeItem("tempCollectionUpdatedData");
      };
    }
  }, [innerChnages]);

  useEffect(() => {
    return () => {
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setAppliedFilterValues({});
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
    };
  }, []);

  //------------------ Handle Trash Modal Button --------------------\\

  const btnInfo1 = [
    {
      btnName: "Delete",
      bgColor: "#E77B7B",
      click: async () => {
        handleDeleteCollection();
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50c878",
      click: () => {
        setOpenRemoveModal(false);
      },
    },
  ];

  //------------------ Handle Cancel Modal Button --------------------\\

  const btnInfo2 = [
    {
      btnName: "Discard",
      bgColor: "#E77B7B",
      click: async () => {
        refetch();

        setIsCollectionEdit("view");
        setShowCollectionTrashIcon(false);
        localStorage.removeItem("tempCollectionRemoveData");
        localStorage.removeItem("tempCollectionUpdatedData");
        setSearch("");
        setOpenCancelModal(false);
        setCollectionUpdate(false);
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50c878",
      click: () => {
        setOpenCancelModal(false);
      },
    },
  ];

  //------------------- Handle AI collection visibility ---------------\\

  const rangeAccessMap = {
    "0-365": hasAccessToSee1To2YearsOldStock,
    "365-730": hasAccessToSee2To3YearsOldStock,
    "730-1095": hasAccessToSee3To4YearsOldStock,
    "1095-1460": hasAccessToSee4To5YearsOldStock,
    "1460-1825": hasAccessToSee5To6YearsOldStock,
    "1825-2190": hasAccessToSee6To7YearsOldStock,
     2190 : hasAccessToSee7To8YearsOldStock,
  };

  const daysAccessMap = {
    30: hasAccessToSeeTop30AICollection,
    60: hasAccessToSeeTop60AICollection,
    90: hasAccessToSeeTop90AICollection,
  };

  const newDesignDaysAccessMap = {
    30: hasAccessToSeeNew30AICollection,
    60: hasAccessToSeeNew60AICollection,
    90: hasAccessToSeeNew90AICollection,
  };

  const checkAccessToShowAiCollection = (days, newDesign, cadDesign, designCount, duplicateStock, restricateStock, range, selectDesign, isOutOfStock, UnderRatio, OverRatio, newDesigns, collectionName) => {
    if (cadDesign && hasAccessToSeeCadDesigns) return true;
    if (newDesign) return newDesignDaysAccessMap[days] === true;
    if (duplicateStock && hasAccessToSeeDuplicateStocks) return true;
    if (restricateStock && hasAccessToSeeRestrictedStocks) return true;
    if (range && rangeAccessMap[range]) return rangeAccessMap[range] === true;
    if (days && daysAccessMap[days]) return daysAccessMap[days] === true;
    if (selectDesign && hasAccessToSeeBinnysSelectDesigns) return true;
    if (isOutOfStock && collectionName === "New Design Out of Stock" && hasAccessToSeeNewDesignOutOfStock) return true;
    if (isOutOfStock && collectionName === "1-2 Years Design Out of stock" && hasAccessToSee1_2Years_DesignOutOfStockDesigns) return true;
    if (isOutOfStock && collectionName === "2-3 Years Design Out of stock" && hasAccessToSee2_3Years_DesignOutOfStockDesigns) return true;
    if (UnderRatio && hasAccessToSeeUnderRatioDesignsDesigns) return true;
    if (OverRatio && hasAccessToSeeOverRatioDiamondDesigns) return true;
    if (newDesigns && hasAccessToNewtDesigns) return true;
    return false;
  };

  //------------------ Render UI Code  --------------------\\

  if (isCollectionLoading || isAiLoading) return <LoadingSmallCard count={24} />;

  if (isError) return <div>Error: {error.message}</div>;

  const handleClickMeta = async (e, data) => {
    e.stopPropagation();
    setInfoModalOpen(true);
    setCollectionFetchId(data?.collectionDetails?._id);
  };

  const collectdata = () => apiClient.get(`/api/v1/collection/getCollectionInfo/${collectionFetchId}`);

  const hasNoResults =
    search &&
    !collections?.collections?.length &&
    !aicollections?.designs?.length;

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      {filterValues?.aiCollectionFilter?.includes("Ai Collection") || filterValues?.aiCollectionFilter?.includes("User-created Collection") ? (
        <Grid
          container
          className="Grid-padding"
          direction="row"
          justifyContent="flex-start"
          sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "28px", rowGap: "30px" }}
        >
          {aicollections && aicollections?.designs?.length > 0 && filterValues?.aiCollectionFilter?.includes("Ai Collection")
            ? aicollections.designs.map((design, index) => {
              let showAiCollection = checkAccessToShowAiCollection(
                design.days,
                design.newDesign,
                design.cadDesign,
                design.designCount,
                design.duplicateStock,
                design.restricateStock,
                design.range,
                design.selectDesign,
                design.isOutOfStock,
                design.UnderRatio,
                design.OverRatio,
                design.newDesigns,
                design.collectionName
              );
              return (
                showAiCollection && (
                  <Grid item key={index}>
                    <Card
                      style={{
                        minWidth: 318,
                        maxWidth: "318px",
                        height: 62,
                        borderRadius: "5px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                      onClick={() => handleAiClick(design)}
                    >
                      {/* Inner Border using ::before */}
                      <div
                        style={{
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          padding: "1px", // Creates the border effect
                          borderRadius: "5px",
                          background: "linear-gradient(90deg, #0000C3, #920E84, #B8AD96, #9A85A1, #3400C7, #920E84)",
                          WebkitMask: "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)", // Mask for inner border effect
                          WebkitMaskComposite: "destination-out",
                          maskComposite: "exclude",
                          pointerEvents: "none", // Ensures no interference with clicks
                        }}
                      />

                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px", width: "100%", position: "relative", zIndex: 1 }}>
                        <div style={{ display: "flex" }}>
                          <SparkleIcon />

                          <div style={{ flex: 1, marginLeft: "10px" }}>
                            <Typography
                              mr={"auto"}
                              fontSize={"14px"}
                              fontWeight={400}
                              fontFamily={"Poppins"}
                              width={"150%"}
                              sx={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                // maxWidth: "145px",
                                transition: "all 0.3s ease-in-out",
                                position: "relative",
                              }}
                            >
                              {design?.collectionName}
                            </Typography>
                            <Typography mr={"auto"} fontSize={"12px"} fontWeight={400} fontFamily={"Karla"} color={"#8B8B8B"}>
                              {"Powered by Ai"}
                            </Typography>
                          </div>
                        </div>

                        <div style={{ minWidth: "40px", textAlign: "right" }}>
                          <Typography fontSize={"16px"} fontWeight={400} fontFamily={"Karla"}>
                            {design?.designCount}
                          </Typography>
                        </div>
                      </div>
                    </Card>
                  </Grid>
                )
              );
            })
            : null}

          {filterValues?.aiCollectionFilter?.includes("User-created Collection") &&
            collectionData.map((ele, i) => (
              <Grid item key={i}>
                <Card style={{ minWidth: 318, maxWidth: "318px", height: 62, borderRadius: "5px" }} onClick={() => handleClick(ele)}>
                  <div style={{ width: "100%", maxWidth: "150px" }}>
                    <Typography
                      mr={"auto"}
                      fontSize={"16px"}
                      fontWeight={400}
                      fontFamily={"Poppins"}
                      width={"150%"}
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        // maxWidth: "150px",
                        transition: "all 0.3s ease-in-out",
                        position: "relative",
                      }}
                    >
                      {ele.collectionDetails.collectionName}
                    </Typography>
                    <Typography mr={"auto"} fontSize={"12px"} fontWeight={400} fontFamily={"Karla"} color={"#8B8B8B"} whiteSpace={"nowrap"} onClick={(e) => handleClickMeta(e, ele)}>
                      {formatDate(ele.collectionDetails.updatedAt !== ele.collectionDetails.createdAt ? ele.collectionDetails.updatedAt : ele.collectionDetails.createdAt)}
                      {/* {formatDate(ele.collectionDetails.createdAt)}(C)&nbsp; &nbsp;
                      {formatDate(ele.collectionDetails.updatedAt)}(M) */}
                    </Typography>
                  </div>

                  {showCollectionTrashIcon ? (
                    <div style={{ display: "flex", gap: "30px" }}>
                      {hasAccessViewName && (
                        <EditIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenEditModal(ele);
                          }}
                        />
                      )}
                      {hasAccessDeleteCollection && (
                        <TrashIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenRemoveModal(ele);
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "80px" }}>
                      {true && (
                        <DescriptionIcon
                          style={{ flexShrink: 0 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDiscriptionModal(ele.collectionDetails);
                          }}
                        />
                      )}

                      <Typography fontSize={"16px"} fontWeight={400} fontFamily={"Karla"}>
                        {ele.collectionDetails.numberOfStyles}
                      </Typography>
                    </div>
                  )}
                </Card>
              </Grid>
            ))}
        </Grid>
      ) : (
        <div style={{ disply: "flex", textAlign: "center", padding: "40px", justifyContent: "center", alignItems: "center" }}>
          <Background />
        </div>
      )}
      {openRemoveModal && <RemoveModal open={openRemoveModal} setOpen={setOpenRemoveModal} btnInfo={btnInfo1} heading=" Do you want to Delete this Collection?" />}
      {openCancelModal && <RemoveModal open={openCancelModal} setOpen={setOpenCancelModal} btnInfo={btnInfo2} heading=" Do you want to Discard this changes?" />}

      {openEditNameModal && (
        <CollectionEditModal
          open={openEditNameModal}
          setOpen={setOpenEditNameModal}
          currentCollectionData={currentCollectionData}
          setCurrentCollectionData={setCurrentCollectionData}
          handleUpdateCollection={handleUpdateCollection}
          collectionData={collectionData}
        />
      )}
      <CollectionDiscriptionModal open={openDiscriptionModal} handleClose={() => setOpenDiscriptionModal(false)} data={discriptionData} setData={setDiscriptionData} />
      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} fetchData={collectdata} title="Collection Details" />
    </>
  );
}

export default CollectionScreen;